/** Ravinaaz Shopify-compatible price range presets. */
(function () {
  'use strict';

  let eventsBound = false;

  function initPricePresets() {
    isolatePresetControls();
    syncPresetFromUrl();
    bindEvents();
    observeAjaxUpdates();
  }

  function isolatePresetControls() {
    document.querySelectorAll('input[name="rz_price_preset"]').forEach((input) => {
      // Exclude the helper radio from Dawn's FormData. Only the two native
      // filter.v.price inputs are sent to Shopify.
      input.setAttribute('form', 'rz-custom-price-controls');
    });
  }

  function syncPresetFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const min = params.get('filter.v.price.gte') || '';
    const max = params.get('filter.v.price.lte') || '';

    document.querySelectorAll('input[name="rz_price_preset"]').forEach((radio) => {
      radio.checked = (radio.dataset.min || '') === min
        && (radio.dataset.max || '') === max
        && (min !== '' || max !== '');
    });

    const hiddenMin = document.getElementById('rz-price-filter-gte');
    const hiddenMax = document.getElementById('rz-price-filter-lte');
    if (hiddenMin) hiddenMin.value = min;
    if (hiddenMax) hiddenMax.value = max;
  }

  function bindEvents() {
    if (eventsBound) return;
    eventsBound = true;

    // Stop Dawn's input listener from submitting the helper radio name.
    document.addEventListener('input', function (event) {
      if (event.target?.name === 'rz_price_preset') event.stopPropagation();
    }, true);

    document.addEventListener('change', function (event) {
      if (event.target?.name === 'rz_price_preset') applyPricePreset(event.target);
    });
  }

  function applyPricePreset(radio) {
    const params = new URLSearchParams(window.location.search);
    const min = radio.dataset.min || '';
    const max = radio.dataset.max || '';

    params.delete('rz_price_preset');
    params.delete('filter.v.price.gte');
    params.delete('filter.v.price.lte');
    params.delete('page');

    if (min !== '') params.set('filter.v.price.gte', min);
    if (max !== '') params.set('filter.v.price.lte', max);

    const hiddenMin = document.getElementById('rz-price-filter-gte');
    const hiddenMax = document.getElementById('rz-price-filter-lte');
    if (hiddenMin) hiddenMin.value = min;
    if (hiddenMax) hiddenMax.value = max;

    dispatchShopifyFilter(params.toString());
  }

  function dispatchShopifyFilter(searchParams) {
    if (window.FacetFiltersForm && typeof window.FacetFiltersForm.renderPage === 'function') {
      window.FacetFiltersForm.renderPage(searchParams);
      return;
    }

    const query = searchParams ? `?${searchParams}` : '';
    window.location.assign(`${window.location.pathname}${query}`);
  }

  function observeAjaxUpdates() {
    const grid = document.getElementById('ProductGridContainer');
    if (!grid || grid.dataset.rzPriceObserver === 'true') return;
    grid.dataset.rzPriceObserver = 'true';

    new MutationObserver(function () {
      window.setTimeout(function () {
        isolatePresetControls();
        syncPresetFromUrl();
      }, 50);
    }).observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPricePresets);
  } else {
    initPricePresets();
  }

  document.addEventListener('shopify:section:load', initPricePresets);
})();
